// extracted by mini-css-extract-plugin
export default {"header":"Address__header___Wgl6n","countryContainer":"Address__countryContainer___ii7__","countryName":"Address__countryName___uMrig"};